<template>
  <Orders :page="'view'" />
</template>

<script>
import Orders from '../../../Shared/Pages/Orders/index.vue'

export default {
  components: {
    Orders
  }
}
</script>
